import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: idevo89
 * id 0893E339-7750-4CAB-8C19-6496711F3C37
 * name window-shutter
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/window-shutter.svg
 * tags
 * - Home Automation 
 */
export const WindowShutterIcon = createSvgIcon(<><path d="M3 4H21V8H19V20H17V8H7V20H5V8H3V4M8 9H16V11H8V9M8 12H16V14H8V12M8 15H16V17H8V15M8 18H16V20H8V18Z" /></>, 'WindowShutterIcon');
export default WindowShutterIcon